module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('c-view', [_c('c-page', [_c('c-navbar'), _vm._v(" "), _c('c-content', [_c('div', {
    staticClass: "integral-panel"
  }, [_c('div', {
    staticClass: "integral"
  }, [_vm._v(_vm._s(_vm.integral))]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("当前可用积分")])]), _vm._v(" "), (_vm.integralDetails.length > 0) ? _c('c-panel-container', [_c('c-panel-title', [_vm._v("积分明细")]), _vm._v(" "), _vm._l((_vm.integralDetails), function(item, index) {
    return _c('c-panel', {
      key: index,
      attrs: {
        "title": item.title,
        "desc": item.time
      }
    }, [(parseInt(item.integral) > 0) ? _c('span', {
      staticClass: "price"
    }, [_vm._v("+" + _vm._s(item.integral))]) : _c('span', {
      staticClass: "sub-price"
    }, [_vm._v(_vm._s(item.integral))])])
  })], 2) : _c('div', {
    staticClass: "empty"
  }, [_vm._v("\n        暂无积分明细\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d2dc82f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/about-me/integral-detail/index.vue
// module id = 1073
// module chunks = 2